
import { getSelectorMap } from '@/pages/dashboard/_config/filterListMap';
import { getSystemFlag } from '@/pages/dashboard/pages/overview/_config/system';

const getSystemLegend = (opt: any, selector: any) => {
  if (selector === null) return;
  try {
    const system: any = getSelectorMap(selector)?.nameEnMap?.os;
    system.Others = '其他';
    system.OfficialWebsite = '官网(非Mac)';
    const systemList = Object.keys(system || {}) || [];
    const legendSystemList = opt.legend.data;
    const legendRich: any = {};
    const legendMap: any = {};
    const xArr = Array(legendSystemList?.length + 11).fill(0).map((_, i) => `icon${  i}`);
    
    legendSystemList?.map((legend: any, index: any) => {
      systemList?.map((item: any) => {
        const cItem = item.replace(/\s*/g, "");
        const cLegend = legend.replace(/\s*/g, "");
        if (cItem === cLegend || system[cItem] === cLegend) {
          legendMap[cItem] = xArr[index];
          legendMap[system[cItem]] = xArr[index];
          if (xArr[index]) {
            legendRich[xArr[index]] = {
              fontSize: 16,
              width: 16,
              height: 16,
              backgroundColor: {
                image: getSystemFlag(item)
              }
            };
          }
        }
      });
    });

    const { undefined, ...newLegendRich } = legendRich;
    opt.legend = {
      ...opt.legend,
      data: opt.legend.data?.map((legendItem: any) => ({
        name: legendItem,
        icon: 'circle',
      })),
      formatter: (name: any) => {
        if (name === 'Others' || name === '其他') return name;
        const richName = legendMap[name?.replace(/\s*/g, "")];
        if (richName) {
          return `{${richName}| } ${name}`;
        }
        return name;
      },
      textStyle: {
        color: "#838697",
        rich: newLegendRich,
      },
    };
  } catch (error) {
    console.log(error);
  }
};

export default getSystemLegend;